"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mf_app_1 = require("@4r/mf-app");
class TokenServiceApiConfig {
    // eslint-disable-next-line class-methods-use-this
    getAuthorization() {
        return `Bearer ${(0, mf_app_1.getService)('TokenService').getToken()}`;
    }
}
exports.default = TokenServiceApiConfig;
